import request from 'services/axios'

const URL = '/messaging/channels/'

/** Which messengers this member is willing to hear on, and whether we could. */
export const getMessagingChannels = async () => {
    const { data } = await request.get<IMessengerChannelsResponse>(URL)
    return data
}

/**
 * Flip one switch. Answers with all of them, because flipping one changes what
 * the others mean: turning بله off is what promotes ایتا to the channel this
 * member is messaged on.
 */
export const updateMessagingChannel = async (
    channel: TDirectChannel,
    enabled: boolean
) => {
    const { data } = await request.patch(URL, { [channel]: enabled })
    return data as IMessengerChannelsResponse
}
